export default __webpack_public_path__ + "static/media/verySevere.fd8e59b0.svg";